import { useState, useEffect, useRef } from "react";

export default function useInfinitePagination(
  items,
  initial = 10,
  increment = 10,
  resetKey = null
) {
    
    const [visibleCount, setVisibleCount] = useState(initial);

    const endOfListRef = useRef(null);

    useEffect(() => {

        setVisibleCount(initial);

    }, [resetKey, initial]);

    useEffect(() => {

    setVisibleCount(prev =>
        Math.min(prev, items.length)
    );

    }, [items.length]);

    useEffect(() => {

        if (!endOfListRef.current) {
            return;
        }

        const observer =
            new IntersectionObserver(entries => {

                if (!entries[0].isIntersecting) {
                    return;
                }

                setVisibleCount(prev =>
                    Math.min(
                        prev + increment,
                        items.length
                    )
                );

            });

        observer.observe(endOfListRef.current);

        return () => observer.disconnect();

    }, [items.length, increment]);

    return {
        visibleItems: items.slice(0, visibleCount), 
        endOfListRef
    };
}